export default [

  {
    value: 'creator',
    displayTextJsonKey: 'users.content.roles.creator'
  },
  {
    value: 'signer',
    displayTextJsonKey: 'users.content.roles.signer'
  },
  {
    value: 'admin',
    displayTextJsonKey: 'users.content.roles.admin'
  },
  {
    value: 'user',
    displayTextJsonKey: 'users.content.roles.user'
  },
  {

    displayTextJsonKey: 'users.content.roles.spectator'
  }
]
